import PropTypes from 'prop-types';
import FreeBetViewImpl from './free-bet-view.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Free bet view displaying a single free bet.
 *
 * @class FreeBetView
 * @private
 * @memberof Mojito.Modules.Betslip.BetslipView.FreeBetsList
 */

/**
 * Callback for handling toggling of free bets.
 *
 * @param {Mojito.Services.Bonus.types.FreeBet} freeBets - Free bet object.
 * @callback Mojito.Modules.Betslip.BetslipView.FreeBetsList.onToggleCallback
 */

/**
 * Free bet view prop types.
 *
 * @property {string} [title] - Free bet title to be rendered.
 * @property {boolean} selected - If it is selected.
 * @property {boolean} disabled - If it is disabled.
 * @property {Mojito.Services.Bonus.types.FreeBet} freeBet - Free bet.
 * @property {Mojito.Modules.Betslip.BetslipView.FreeBetsList.onToggleCallback} toggleCallback - Callback when toggling.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.FreeBetsList.FreeBetView
 */
const propTypes = {
    title: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    freeBet: PropTypes.object,
    toggleCallback: PropTypes.func.isRequired,
};

export default UIView('FreeBetView', FreeBetViewImpl, propTypes);
